<h1>New Complaint</h1>

<form [formGroup]="newComplaintForm" (ngSubmit)="onSubmit()">
    <div class="validation-summary-errors" *ngIf="newComplaintForm.touched && newComplaintForm.invalid">
        <ul>
            <li *ngIf="newComplaintForm.touched && newComplaintForm.controls['branchId'].invalid">Branch can't be empty.</li>
            <li *ngIf="newComplaintForm.touched && newComplaintForm.controls['title'].invalid">Title can't be empty.</li>
            <li *ngIf="newComplaintForm.touched && newComplaintForm.controls['subTitle'].invalid">SubTitle can't be empty.</li>
            <li *ngIf="newComplaintForm.touched && newComplaintForm.controls['customerName'].invalid">Customer Name can't be empty.</li>
            <li *ngIf="newComplaintForm.touched && newComplaintForm.controls['customerPhone'].invalid">Customer Phone can't be empty.</li>
            <li *ngIf="newComplaintForm.touched && newComplaintForm.controls['description'].invalid">Description can't be empty.</li>
            <li *ngIf="newComplaintForm.touched && newComplaintForm.controls['status'].invalid">Status can't be empty.</li>
        </ul>
    </div>
    <div class="form-group">
        <label for="branchId">Branch</label>
        <ng-select
            [items]="branches"
            bindLabel="branchName"
            bindValue="branchId"
            formControlName="branchId"
            class="w-md-25"
            [ngClass]="{ 'input-validation-error': newComplaintForm.touched && newComplaintForm.controls['branchId'].invalid }"
        >
        </ng-select>
    </div>
    <div class="form-group">
        <label for="title">Title</label>
        <ng-select
            [items]="compliansTitles"
            bindLabel="name"
            bindValue="value"
            formControlName="title"
            class="w-md-25"
            [ngClass]="{ 'input-validation-error': newComplaintForm.touched && newComplaintForm.controls['title'].invalid }"
            (change)="onChange($event)"
        >
        </ng-select>
    </div>
    <div class="form-group">
        <label for="subTitle">SubTitle</label>
        <ng-select
            [items]="compliansSubTitlesCurrent"
            bindLabel="name"
            bindValue="value"
            formControlName="subTitle"
            class="w-md-25"
            [ngClass]="{ 'input-validation-error': newComplaintForm.touched && newComplaintForm.controls['subTitle'].invalid }"
        >
        </ng-select>
    </div>
    <div class="form-group">
        <label for="customerName">Customer Name</label>
        <input
            id="customerName"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="customerName"
            [ngClass]="{ 'input-validation-error': newComplaintForm.touched && newComplaintForm.controls['customerName'].invalid }"
        />
    </div>
    <div class="form-group">
        <label for="customerPhone">Customer Phone</label>
        <input
            id="customerPhone"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="customerPhone"
            [ngClass]="{ 'input-validation-error': newComplaintForm.touched && newComplaintForm.controls['customerPhone'].invalid }"
        />
    </div>
    <div class="form-group">
        <label for="status">Status</label>
        <ng-select
            [items]="compliansStatus"
            bindLabel="name"
            bindValue="value"
            formControlName="status"
            class="disabled-ng-select w-md-25"
            [ngClass]="{ 'input-validation-error': newComplaintForm.touched && newComplaintForm.controls['status'].invalid }"
        >
        </ng-select>
    </div>
    <div class="form-group">
        <label for="description">Description</label>
        <textarea
            rows="5"
            id="description"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="description"
            [ngClass]="{ 'input-validation-error': newComplaintForm.touched && newComplaintForm.controls['description'].invalid }"
        >
        </textarea>
    </div>
    <div class="form-group">
        <button class="btn btn-primary btn-sm" type="submit" [disabled]="formBusy">Create</button>
        <button class="btn btn-secondary btn-sm ml-2" type="button" (click)="location.back()">Cancel</button>
    </div>
</form>
